import { Flex, FlexProps } from '@chakra-ui/react';
import { ISidebarItem } from 'types/layout/ISidebarItem';
import SidebarItem from './SidebarItem';

export type SidebarContentProps = FlexProps & {
  items: ISidebarItem[];
};

const SidebarContent = ({ items, ...props }: SidebarContentProps) => {
  const renderNavItems = items.map(({ id, ...item }) => <SidebarItem key={id} {...item} />);
  return (
    <Flex
      pt={8}
      px={3}
      bg="linear-gradient(178deg,var(--chakra-colors-base1Colour-400),var(--chakra-colors-base1Colour-500) 500%)"
      flexDir="column"
      {...props}
    >
      {renderNavItems}
    </Flex>
  );
};

export default SidebarContent;
